// extracted by mini-css-extract-plugin
export var locationCard = "_hb-0";